import clsx from 'clsx'
import React from 'react'
import Imgix, { Background } from 'react-imgix'
import { ContentColumnDefinition, ContentColumnType } from '../../../data/types'
import ParagraphComponent from '../ParagraphComponent'
import useStyles from './ContentColumnsComponent.styles'
import { ContentColumnsComponentProps } from './ContentColumnsComponentProps'

interface ColumnComponentProps {
  column: ContentColumnDefinition
}

const ColumnComponent: React.FC<ColumnComponentProps> = ({ column }) => {
  const classes = useStyles()
  switch (column.type) {
    case ContentColumnType.Image:
      return <Imgix src={column.src} className={classes.image} />
    case ContentColumnType.Text:
      return <ParagraphComponent {...column} className={classes.paragraph} />
    default:
      return null
  }
}

const ContentColumnsComponent: React.FC<ContentColumnsComponentProps> = ({
  columns,
  backgroundImage
}) => {
  const classes = useStyles()
  return (
    <Background
      className={classes.contentColumnsBackground}
      src={backgroundImage?.src ?? ''}
    >
      <div className={classes.contentColumns}>
        {columns.map((column, index) => (
          <div
            key={index}
            className={clsx(
              classes.column,
              column.type === ContentColumnType.Image && classes.rise
            )}
          >
            <ColumnComponent column={column} />
          </div>
        ))}
      </div>
    </Background>
  )
}

export default ContentColumnsComponent
